import { OrderProto } from "@noom/noom-contracts/noom_contracts/billing/bms/orders/orders_service";
import { BillingCyclePreviewProto } from "@noom/noom-contracts/noom_contracts/billing/bms/subscriptions/billing_cycle_preview";
import { InvoiceProto } from "@noom/noom-contracts/noom_contracts/billing/bms/invoices/invoice";
import { MoneyProto } from "@noom/noom-contracts/noom_contracts/lib/money";

export function extractBillingCycles(order: OrderProto): {
  initialBillingCycle?: BillingCyclePreviewProto;
  recurringBillingCycle?: BillingCyclePreviewProto;
} {
  let billingCycles: BillingCyclePreviewProto[] | undefined;
  for (const action of order.executionActions ?? []) {
    if (action.createSubscription?.billingCycles?.length) {
      billingCycles = action.createSubscription.billingCycles;
      break;
    }
    if (action.modifySubscription?.billingCycles?.length) {
      billingCycles = action.modifySubscription.billingCycles;
      break;
    }
    if (action.updatePaymentSchedule?.billingCycles?.length) {
      billingCycles = action.updatePaymentSchedule.billingCycles;
      break;
    }
  }
  if (!billingCycles?.length) {
    throw new Error("Could not find billing cycles in order response");
  }
  if (billingCycles.length > 2) {
    throw new Error(
      `Expected at most 2 billing cycles but received ${billingCycles.length}`
    );
  }
  if (billingCycles.length === 1) {
    return {
      recurringBillingCycle: billingCycles[0],
    };
  }
  return {
    initialBillingCycle: billingCycles[0],
    recurringBillingCycle: billingCycles[1],
  };
}

export function extractInvoice(order: OrderProto): InvoiceProto | undefined {
  for (const action of order.executionActions ?? []) {
    if (action.createInvoice?.invoice) {
      return action.createInvoice.invoice;
    }
  }
  return undefined;
}

export function getRefundAmount(order: OrderProto): MoneyProto | undefined {
  for (const action of order.executionActions ?? []) {
    const creditNoteAmount =
      action.createCreditNote?.creditNote?.lineItems?.[0]?.amount;
    if (
      creditNoteAmount &&
      (creditNoteAmount.units || creditNoteAmount.nanos)
    ) {
      return creditNoteAmount;
    }
  }
  return undefined;
}
